// alertScopeService.js

import { message } from 'antd';
import api from './api';

// Fetch all scope affirmations (GET)
export const fetchScopeAffirmations = async () => {
  try {
    const response = await api.get('/alert_scope_alert_type_affirmations');
    message.success('Scope affirmations fetched successfully!');
    return response.data;
  } catch (error) {
    message.error('Error fetching scope affirmations.');
    console.error('Error fetching scope affirmations:', error);
    throw error;
  }
};

// Fetch specific scope affirmation (GET)
export const fetchScopeAffirmation = async (scope) => {
  try {
    const response = await api.get('/alert_scope_alert_type_affirmations', { params: { scope } });
    message.success(`Scope affirmation for ${scope} fetched successfully!`);
    return response.data;
  } catch (error) {
    message.error(`Error fetching scope affirmation for ${scope}.`);
    console.error(`Error fetching scope affirmation for ${scope}:`, error);
    throw error;
  }
};

// Create new scope affirmation (POST)
export const createScopeAffirmation = async (scopeData) => {
  try {
    const response = await api.post('/alert_scope_alert_type_affirmations', scopeData);
    message.success('Scope affirmation created successfully!');
    return response.data;
  } catch (error) {
    message.error('Error creating scope affirmation.');
    console.error('Error creating scope affirmation:', error);
    throw error;
  }
};

// Update scope affirmation (PUT)
export const updateScopeAffirmation = async (scopeData) => {
  try {
    const response = await api.put('/alert_scope_alert_type_affirmations', scopeData);
    message.success('Scope affirmation updated successfully!');
    return response.data;
  } catch (error) {
    message.error('Error updating scope affirmation.');
    console.error('Error updating scope affirmation:', error);
    throw error;
  }
};

// Delete scope affirmation (DELETE)
export const deleteScopeAffirmation = async (scope) => {
  try {
    const response = await api.delete('/alert_scope_alert_type_affirmations', { params: { scope } });
    message.success(`Scope affirmation for ${scope} deleted successfully!`);
    return response.data;
  } catch (error) {
    message.error(`Error deleting scope affirmation for ${scope}.`);
    console.error(`Error deleting scope affirmation for ${scope}:`, error);
    throw error;
  }
};


// Fetch all clause definitions (ID + clause_txt)
export const fetchAllClauses = async () => {
  try {
    const response = await api.get('/alert_clause_definition');
    return response.data;
  } catch (error) {
    console.error('Error fetching clause definitions:', error);
    throw error;
  }
};
